import styled from 'styled-components';
import { Flex, FlexProps } from '../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({
        displayName: 'ContentPromotionStats',
    })
    .attrs<FlexProps>({
        width: '100%',
        p: 2,
    })``;
